/**
 * Subsequent sources overwrite property assignments of previous sources.
 */
export function merge<Value extends Object = any>(
    target: Partial<Value>,
    ...sources: Value[]
): Value;
export function merge<Value extends Object = any>(...sources: Value[]): Value {
    return _merge(new Set(), ...sources);
}

function _merge<Value extends Object = any>(
    seen: Set<any>,
    ...sources: Value[]
): Value {
    const target: Partial<Value> = {};
    for (let i = 0; i < sources.length; i++) {
        if (!sources[i]) {
            continue;
        }

        if (seen.has(sources[i])) {
            continue;
        }
        seen.add(sources[i]);

        for (let key in sources[i]) {
            if (sources[i][key] === undefined) {
            } else if (sources[i][key] === target[key]) {
            } else if (isLiteral(sources[i][key]) && isLiteral(target[key])) {
                target[key] = _merge(seen, target[key], sources[i][key]);
            }
            // else if (
            //     this.isLiteral(sources[i][key])) {
            //     target[key] = this.merge(sources[i][key]);
            // }
            else {
                const value = sources[i][key];
                target[key] = Array.isArray(value)
                    ? (value.slice() as any)
                    : value;
            }
        }
    }
    return target as Value;
}

export function mergeShallow<Value extends Object = any>(
    target: Partial<Value>,
    ...sources: Value[]
): Value;
export function mergeShallow<Value extends Object = any>(
    ...sources: Value[]
): Value {
    const target: Partial<Value> = {};
    for (let i = 0; i < sources.length; i++) {
        if (!sources[i]) {
            continue;
        }

        for (let key in sources[i]) {
            if (sources[i][key] === undefined) {
                continue;
            }

            if (sources[i].hasOwnProperty(key)) {
                target[key] = sources[i][key];
            }
        }
    }
    return target as Value;
}

export function isLiteral(o: any): boolean {
    if (!o) {
        return false;
    }

    if (typeof o !== "object") {
        return false;
    }

    return Object.getPrototypeOf(o) === Object.prototype;

    // if (typeof o === 'object' && o.__proto__ === Object.prototype)
    //     return true;

    //@source https://stackoverflow.com/questions/4320767/check-that-value-is-object-literal
    // if( Object.prototype.toString.call( o ) === '[object Object]' ) {
    //     return true;
    // }

    // return false;
}
